import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import Decimal from 'decimal.js';
import { VentrncotizacionService } from "../venservicios/ventrncotizacion.service";

import { Vendetcotizacion } from "../veninterfaces/vendetcotizacion";
@Injectable({
  providedIn: 'root'
})
export class VenenccotizacionService {

  vendetcotizacion = {}
  cotizacionesMap = {}
  public decimalesTotal: number;
  public decimalesCosto: number;
  public decimalesCantidad: number;
  public decimalesPrecio: number;
  public decimalesTOTALFAC: number;
  public way: string;

  constructor(
    private http: HttpClient, public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario, private confIniciales: ConfInicialesService,
    public ventrncotizacionService: VentrncotizacionService,
    private utilitariosService: UtilitariosService,

  ) {  this.way = sessionStorage.getItem('way');}
  registrarcotizacion(encabezado) {
    this.cotizacionesMap[encabezado.ENCCOTIZA_NUMERO] = encabezado
  }
  obtenerDetalle(numeroCotizacion): Vendetcotizacion[] {
    if (!this.vendetcotizacion[numeroCotizacion]) {
      this.vendetcotizacion[numeroCotizacion] = []
    }
    return this.vendetcotizacion[numeroCotizacion]
  }
  agregarfila(numeroCotizacion, tipodet) {
    // if (!this.vendetcotizacion[numeroCotizacion]) {
    //   this.vendetcotizacion[numeroCotizacion] = []
    // }
    const cotizacion = this.cotizacionesMap[numeroCotizacion]

    const linea = cotizacion.detalle.length + 1;
    const detalle: Vendetcotizacion = {
      TRNCOTIZA_NUMERO: '',
      ENCCOTIZA_NUMERO: numeroCotizacion,
      DETCOTIZA_LINEA: linea,
      COM_CODIGO: '01',
      BOD_CODIGO: '',
      DETCOTIZA_CODIGO: '',
      DETCOTIZA_DESCRIPCION: '',
      DETCOTIZA_UNIDAD: '',
      DETCOTIZA_CANTIDAD: Number(0).toFixed(this.decimalesCantidad),
      DETCOTIZA_COSTO: Number(0).toFixed(this.decimalesCosto),
      DETCOTIZA_TOTAL: Number(0).toFixed(this.decimalesTotal),
      DETCOTIZA_TIPODET: tipodet,
      PRO_CODIGO: '',
      PRO_NOMBRE: '',
    }
    cotizacion.detalle.push(detalle)
    cotizacion.detalle = [...cotizacion.detalle]
  }
  calculartotal(numeroCotizacion) {
    const cotizacion = this.cotizacionesMap[numeroCotizacion]
    //console.log(cotizacion)
    let totalenc = 0;
    let utilidad = 0
    for (const fila of cotizacion.detalle) {
      fila.DETCOTIZA_TOTAL = this.utilitariosService.multiplicar(fila.DETCOTIZA_CANTIDAD, fila.DETCOTIZA_COSTO)
      fila.DETCOTIZA_CANTIDAD = this.utilitariosService.formatear(fila.DETCOTIZA_CANTIDAD, this.decimalesCantidad)
      fila.DETCOTIZA_COSTO = this.utilitariosService.formatear(fila.DETCOTIZA_COSTO, this.decimalesCosto)
      fila.DETCOTIZA_TOTAL = this.utilitariosService.formatear(fila.DETCOTIZA_TOTAL, this.decimalesTotal)
      totalenc = this.utilitariosService.sumar(totalenc, fila.DETCOTIZA_TOTAL)
    }
    cotizacion.ENCCOTIZA_TOTCOSTO = totalenc

    cotizacion.ENCCOTIZA_UTILIDAD = this.utilitariosService.multiplicar(cotizacion.ENCCOTIZA_TOTCOSTO, cotizacion.ENCCOTIZA_PORCEUTIL)
    cotizacion.ENCCOTIZA_PRECIOTOT = this.utilitariosService.sumar(cotizacion.ENCCOTIZA_TOTCOSTO, cotizacion.ENCCOTIZA_UTILIDAD)
    cotizacion.ENCCOTIZA_PRECIOUNI = this.utilitariosService.dividir(cotizacion.ENCCOTIZA_PRECIOTOT, cotizacion.ENCCOTIZA_CANTIDAD)
    cotizacion.ENCCOTIZA_TOTREALPRO=this.utilitariosService.sumar(cotizacion.ENCCOTIZA_CANTIDAD,cotizacion.ENCCOTIZA_MACULATURA)
    //*formatear resultados
    cotizacion.ENCCOTIZA_TOTCOSTO = this.utilitariosService.formatear(totalenc, this.decimalesCosto);
    cotizacion.ENCCOTIZA_UTILIDAD = this.utilitariosService.formatear(cotizacion.ENCCOTIZA_UTILIDAD, 2);
    cotizacion.ENCCOTIZA_PORCEUTIL = this.utilitariosService.formatear(cotizacion.ENCCOTIZA_PORCEUTIL, 2);
    cotizacion.ENCCOTIZA_PRECIOTOT = this.utilitariosService.formatear(cotizacion.ENCCOTIZA_PRECIOTOT, this.decimalesTOTALFAC);
    cotizacion.ENCCOTIZA_PRECIOUNI = this.utilitariosService.formatear(cotizacion.ENCCOTIZA_PRECIOUNI, this.decimalesPrecio);
    cotizacion.ENCCOTIZA_TOTREALPRO = this.utilitariosService.formatear(cotizacion.ENCCOTIZA_TOTREALPRO, this.confIniciales.getNumDecSist());
    //console.log(this.cotizacionesMap[numeroCotizacion])
  }
  encontrararticulo(articulo) {
    return this.http.post(this.way + '/inventario/busqueda/1d76636e84b87', {
      elementos: {
        parametro:articulo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  encontrarbodega(bodega) {
    return this.http.post(this.way + '/produccion/ordenprod/3aecc5fbb56d7800000', {
      elementos: {
        bodega
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getTipoProceso(ArtCodigo): Promise<any[]> {
    return this.http.post<any>(this.way + '/produccion/ordenprod/20eef659c677860000', {
      elementos: {
        ArtCodigo
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
